import { useState } from "react";
import { GBP } from "../types/Listing";

export const useGBP = (websiteId?: number) => {
  const [gbpFiches] = useState<GBP[]>([]);
  const [error, setError] = useState<string | null>(null);
  const clearError = () => {
    setError(null);
  };
  return {
     allGbpFiches: gbpFiches,
     error,
        clearError,
   };
};
